import { gql } from 'apollo-angular';

export default gql`
  query GetBackendSignal($key: ID!) {
    getBackendSignal(key: $key) {
      key
      value
      updated_at
    }
  }

  subscription OnBackendSignalChanged($key: ID!) {
    onBackendSignalChanged(key: $key) {
      key
      value
      updated_at
      event_type
    }
  }
`;
